module.exports = __webpack_public_path__ + "img/1-md.826fd0ba.jpg";